import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import  './MergedReport.css';


const MergedReport = () => {

    const daysBetweenDates = () => {
      const today = new Date();
      const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const diffTime = Math.abs(today - firstOfMonth);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    const formatDateRangeWithOrdinal = (startDate, endDate) => {
      const startMoment = moment(startDate);
      const endMoment = moment(endDate);
    
      const startDay = startMoment.date();
      const startMonth = startMoment.format('MMMM');
      const startYear = startMoment.year();
      const startDayWithSuffix = startDay + getOrdinalSuffix(startDay);
    
      const endDay = endMoment.date();
      const endMonth = endMoment.format('MMMM');
      const endYear = endMoment.year();
      const endDayWithSuffix = endDay + getOrdinalSuffix(endDay);
    
      return `${startDayWithSuffix} ${startMonth} ${startYear} - ${endDayWithSuffix} ${endMonth} ${endYear}`;
    };

    const [loading, setLoading] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - daysBetweenDates() + 1)));
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    const [total, setTotal] = useState('');
    const [locationTeamTotal, setLocationTeamTotal] = useState('');
    const [telematicTeamTotal, setTelematicTeamTotal] = useState('');
    const [chargedByTelematicTeam, setChargedByTelematicTeam] = useState([])
    const [telematicTeamLocationWise, setTelematicTeamLocationWise] = useState([])
    const [locationWise, setLocationWise] = useState([])
    const [dateRange, setDateRange] = useState('')
    const [telematicsTotalCount, setTelematicsTotalCount] = useState('')
    const [locationTotalCount, setLocationTotalCount] = useState('')
  
    const [telematicTeamTotalToll, setTelematicsTeamTotalToll] = useState('');
    const [telematicsTotalCountToll, setTelematicsTotalCountToll] = useState('')
    const [telematicTeamLocationWiseToll, setTelematicTeamLocationWiseToll] = useState([])
    const [chargedByTelematicTeamToll, setChargedByTelematicTeamToll] = useState([])

    const handleGenerateReport = () => {
      setLoading(true)
      const fromDate = new Date(selectedFromDate).toDateString()
      const toDate = new Date(selectedToDate).toDateString()
      axios.post(baseURL + "/generate_bcf_toll_report", {
        'from': fromDate, 
        'to': toDate,
        'admin_id': foundUser['tm_id']
      }).then((res) => {
        const formattedDateRange1 = formatDateRangeWithOrdinal(res.data.from_date, res.data.to_date);
        setDateRange(formattedDateRange1)
        const myDataSet = res.data.report;
        const myDataSetToll = res.data.report_toll;
        let telematicsTotal = 0
        let telematicsTotalToll = 0
        let locationTotal = 0
        let usSum = 0
        let canadaSum = 0
        let telematicsTotalCount = 0
        let telematicsTotalCountToll = 0
        let locationTotalCount = 0
        for (var index = 0; index < res.data.report.length; index++) {
          const val = myDataSet[index];
          telematicsTotal = telematicsTotal + val.telematic_team_total_sum
          locationTotal = locationTotal + val.location_team_total_sum
          telematicsTotalCount = telematicsTotalCount + val.telematic_team_count
          locationTotalCount = locationTotalCount + val.location_team_count
          if(val.location_name == 'ORD' || val.location_name == 'ATL' || val.location_name == 'DEN' || val.location_name == 'AUR' || val.location_name == 'MCO' || val.location_name == 'AURORA')
          {
            usSum = usSum + val.location_team_total_sum + val.telematic_team_total_sum
          }
          else{
            canadaSum = canadaSum + val.location_team_total_sum + val.telematic_team_total_sum
          }
        }
        setTelematicTeamTotal(telematicsTotal)
        setLocationTeamTotal(locationTotal)
        setTotal(telematicsTotal+locationTotal)
        setLocationTotalCount(locationTotalCount)
        setTelematicsTotalCount(telematicsTotalCount)

        const telematicsTeam = res.data.report
        .filter((val1) => val1.telematic_team_total_sum !== 0)
        .map((val1) => {
          return { name: val1.location_name, total: val1.telematic_team_total_sum, count: val1.telematic_team_count, tax: val1.telematic_team_tax_sum, amount:val1.telematic_team_amount_sum }
        });
        setTelematicTeamLocationWise(telematicsTeam)

        const locationTeam = res.data.report
        .filter((val2) => val2.location_team_total_sum !== 0)
        .map((val2) => {
          return { name: val2.location_name, total: val2.location_team_total_sum, count: val2.location_team_count, tax: val2.location_team_tax_sum, amount:val2.location_team_amount_sum}
        });
        setLocationWise(locationTeam)

        const telematicsTeamCharged = Object.entries(res.data.telematics_team_charged).map(([name, total]) => {
          return { name, total };
        });
        setChargedByTelematicTeam(telematicsTeamCharged)

        if(res.data.report_toll != null)
        {
          for (var index = 0; index < res.data.report_toll.length; index++) {
            const val = myDataSetToll[index];
            telematicsTotalToll = telematicsTotalToll + val.telematic_team_total_sum_toll
            telematicsTotalCountToll = telematicsTotalCountToll + val.telematic_team_count_toll
          }
          setTelematicsTeamTotalToll(telematicsTotalToll)
          setTelematicsTotalCountToll(telematicsTotalCountToll)

          const telematicsTeamToll = res.data.report_toll
          .filter((val1) => val1.telematic_team_total_sum_toll !== 0)
          .map((val1) => {
            return { name: val1.location_name, total: val1.telematic_team_total_sum_toll, count: val1.telematic_team_count_toll, tax: val1.telematic_team_tax_sum_toll, amount:val1.telematic_team_amount_sum_toll }
          });
          setTelematicTeamLocationWiseToll(telematicsTeamToll)

          const telematicsTeamChargedToll = Object.entries(res.data.telematics_team_charged_toll).map(([name, total]) => {
            return { name, total };
          });
          setChargedByTelematicTeamToll(telematicsTeamChargedToll)
        }
        setShowTable(true)
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false); // hide spinner
      });
    }


    return(
      <div className='body_class'>
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <PuffLoader color="#00308F" loading={true} size={200} />
          </div>
        </div>
      )}
      <div className='container-fluid'>
        <h4>BCF And Tolls Report</h4>
        <div className="mt-3">
          {foundUser['tm_accessRole']['Fleet']['Edit'] === true && (
            <>
              <div className='row p-4 align-items-center'>
                <div className="col-auto">
                  <label htmlFor="datepicker" className="form-label">Start Date:</label>
                </div>
                <div className='col-2'>
                  <DatePicker
                    id="start-date"
                    selected={selectedFromDate}
                    onChange={(date) => setSelectedFromDate(date)}
                    className="form-control"
                  />
                </div>
                <div className="col-auto">
                  <label htmlFor="datepicker" className="form-label">To Date:</label>
                </div>
                <div className='col-2'>
                  <DatePicker
                    id="end-date"
                    selected={selectedToDate}
                    onChange={(date) => setSelectedToDate(date)}
                    className="form-control"
                  />
                </div>
                <div className="col-auto">
                  <Button size='large' variant="contained" component="span" className="btn btn-primary" onClick={handleGenerateReport}>Generate Report</Button>
                </div>
              </div>
            </>
          )}
        </div>
        {showTable &&
          <div className="row" >
            <div className="table-container col-6">
              <hr/>
              <h4 style={{backgroundColor:""}}>BCF charges | {dateRange}</h4>
              <hr/>
              <div className="currency-table2">
                <table className="charged-amounts-table">
                  <thead>
                    <tr>
                      <th>Total Amount</th>
                      <th>Location Team</th>
                      <th>Telematic Team</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>${total.toLocaleString()}</td>
                      <td>${locationTeamTotal.toLocaleString()}</td>
                      <td>${telematicTeamTotal.toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="currency-table2-container">
                <div className="currency-table2">
                  <br></br>
                  <h5>Charged by Telematic Team</h5>
                  <table className="charged-amounts-table">
                      <thead>
                        <tr>
                          {chargedByTelematicTeam.map((person, index) => (
                            <th key={index}>{person.name}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {chargedByTelematicTeam.map((person, index) => (
                            <td key={index}>${person.total.toLocaleString()}</td>
                          ))}
                        </tr>
                      </tbody>
                  </table>
                  <table className="charged-amounts-table">
                      <thead>
                          <tr>
                              <th>Location</th>
                              <th>Net Amount</th>
                              <th>Tax</th>
                              <th>Total Amount</th>
                              <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                          {telematicTeamLocationWise.map((loc, index) => (
                              <tr key={index}>
                                  <td>{loc.name}</td>
                                  <td>${loc.amount.toLocaleString()}</td>
                                  <td>${loc.tax.toLocaleString()}</td>
                                  <td>${loc.total.toLocaleString()}</td>
                                  <td>{loc.count.toLocaleString()}</td>
                              </tr>
                          ))}
                          <tr style={{fontWeight:"bold"}}>
                            <td colSpan={3}>Total</td>
                            <td>${telematicTeamTotal.toLocaleString()}</td>
                            <td>{telematicsTotalCount.toLocaleString()}</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
              
              </div>
              <div className="currency-table2-container">
                <div className="currency-table2">
                  <br></br>
                  <h5>Applied At Location</h5>
                  <table className="charged-amounts-table">
                      <thead>
                          <tr>
                              <th>Location</th>
                              <th>Net Amount</th>
                              <th>Tax</th>
                              <th>Total Amount</th>
                              <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                          {locationWise.map((loc, index) => (
                              <tr key={index}>
                                  <td>{loc.name}</td>
                                  <td>${loc.amount.toLocaleString()}</td>
                                  <td>${loc.tax.toLocaleString()}</td>
                                  <td>${loc.total.toLocaleString()}</td>
                                  <td>{loc.count.toLocaleString()}</td>
                              </tr>
                          ))}
                          <tr style={{fontWeight:"bold"}}>
                            <td colSpan={3}>Total</td>
                            <td>${locationTeamTotal.toLocaleString()}</td>
                            <td>{locationTotalCount.toLocaleString()}</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="table-container col-6">
              <hr/>
              <h4 style={{backgroundColor:""}}>Tolls charges | {dateRange}</h4>
              <hr/> 
              <div className="currency-table2-container">
                <div className="currency-table2">
                  <h5>Charged by Telematic Team</h5>
                  <table className="charged-amounts-table">
                      <thead>
                        <tr>
                          {chargedByTelematicTeamToll.map((person, index) => (
                            <th key={index}>{person.name}</th>
                          ))}
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {chargedByTelematicTeamToll.map((person, index) => (
                            <td key={index}>${person.total.toLocaleString()}</td>
                          ))}
                          <td>${telematicTeamTotalToll.toLocaleString()}</td>
                        </tr>
                        
                      </tbody>
                  </table>
                  <br></br>
                  <table className="charged-amounts-table">
                      <thead>
                          <tr>
                              <th>Location</th>
                              <th>Toll Amount</th>
                              <th>Admin Fees</th>
                              <th>Total Amount</th>
                              <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                          {telematicTeamLocationWiseToll.map((loc, index) => (
                              <tr key={index}>
                                  <td>{loc.name}</td>
                                  <td>${loc.amount.toLocaleString()}</td>
                                  <td>${loc.tax.toLocaleString()}</td>
                                  <td>${loc.total.toLocaleString()}</td>
                                  <td>{loc.count.toLocaleString()}</td>
                              </tr>
                          ))}
                          <tr style={{fontWeight:"bold"}}>
                            <td colSpan={3}>Total</td>
                            <td>${telematicTeamTotalToll.toLocaleString()}</td>
                            <td>{telematicsTotalCountToll.toLocaleString()}</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    )
}

export default MergedReport;